module.exports = __webpack_public_path__ + "img/Neon-Ferris.699e1862.svg";